import config from "../../config";
import { GET_STATES } from "./types";

export const GetStatesAction = () => async (dispatch) => {
    try {
        const res = await config.getApi(
            config.services.states(),
            config.defaultHeaders
        );
        if (res) {
            dispatch({ type: GET_STATES, payload: res.response.data });
        }
    } catch (e) {
        console.log(e);
    }
};
